/**
 * Sets a loading state with a delay. The loading indicator will only be shown
 * if the process takes longer than the specified delay.
 *
 * @param {React.Dispatch<React.SetStateAction<boolean>>} setIsLoading - The state setter function to manage the loading state.
 * @param {number} [delay=300] - The delay (in milliseconds) before showing the loading state. Default is 300ms.
 *
 * @returns {Function} - A cleanup function to stop the loading indicator if called before the delay completes.
 * @example - usage
 * // Set true state
 * const cancelLoading = setLoadingWithDelay(setIsLoading, 500);
 *
 * // Set false state
 *  cancelLoading();
 */
export const setLoadingWithDelay = (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  delay = 400,
) => {
  let timer = setTimeout(() => setIsLoading(true), delay);

  return () => {
    clearTimeout(timer);
    setIsLoading(false);
  };
};
